import React from 'react'
import { StyledFeatureVariable } from '@mc/feature-variables'
import { withI18nContext, useTranslation } from '@mc/i18n'
import { i18nInstance } from '../../i18n'
import { PROMO_FEATURE_FLAG, PROMO_I18N_NAMESPACE } from '../../lib/constants'

const PromotionErrorTextComp = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <StyledFeatureVariable
      flagName={PROMO_FEATURE_FLAG}
      variableName='discount_modal_promo_overriden_body'
      defaultCopy={t(
        'common.home.modals.discount.promotionAppliedOnError.body',
      )}
    />
  )
}

export const PromotionErrorText = withI18nContext(i18nInstance)(
  PromotionErrorTextComp,
)
